import { FunctionComponent, Fragment } from 'react'
import { RenderIfProps } from './types'

export const RenderIf: FunctionComponent<RenderIfProps> = props => {
  const { condition, children } = props

  return condition ? <Fragment>{children}</Fragment> : null
}
